












































































































import { defineComponent, ref, computed, onMounted, watch } from "@vue/composition-api";
import useLogbook from "@/store/useLogbook";
import useFavouriteJourneys from "@/store/useFavouriteJourneys";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./Sensors/SensorHeader.vue"),
    },
    setup(_, { root }) {

        const { logbookItems } = useLogbook("2023-01-01,2800-12-31");
        const { favouriteJourneys } = useFavouriteJourneys();
        const currentDate = ref(new Date(Date.now()).toISOString().substring(0, 10));
        let startDate = ref("");
        let endDate = ref("");
        let showDatePickerDialog = ref<boolean>(false);
        let showFavouriteJourneysDialog = ref<boolean>(false);
        const panel = ref();
        const dates = ref();
        const dateItem = ref("");
        let uniqueDates = ref();
        //const imageIds = ref(['image1.jpg', 'image2.jpg', 'image3.jpg', 'image4.jpg', 'image5.jpg']);
        //const isFavourite = ref(true);
        //const isNotFavourite = ref(false);


        const dateRangeText = computed(() => {
            let firstDay = dates.value[0];
            let lastDay = dates.value[1] ? dates.value[1] : dates.value[0];

            if (dates.value[1]) {
                if (firstDay > lastDay) {
                    [firstDay, lastDay] = [lastDay, firstDay];
                }
                return `From ${formatDateNoYear(firstDay)} to ${formatDate(lastDay)}`;
            } else {
                return formatDate(firstDay);
            }
        });

        const getUniqueDates = () => {
            let firstDay = dates.value[0];
            let lastDay = dates.value[1] ? dates.value[1] : dates.value[0];
            if (firstDay > lastDay) {
                firstDay = lastDay;
                lastDay = dates.value[0];
            }
            const uniqueDates = new Set();
            logbookItems.value.forEach((item) => {
                const date = new Date(item.gpsTimestamp).toISOString().slice(0, 10);
                if (date >= firstDay && date <= lastDay) {
                    uniqueDates.add(date);
                }
            });
            return Array.from(uniqueDates);
        };

        function formatDate(dateString) {
            let date = new Date(dateString);
            const day = date.getDate()
            const month = date.toLocaleString('en-US', { month: 'long' });
            const year = date.getFullYear();

            let daySuffix = 'th';
            if (day === 1 || day === 21 || day === 31) {
                daySuffix = 'st';
            } else if (day === 2 || day === 22) {
                daySuffix = 'nd';
            } else if (day === 3 || day === 23) {
                daySuffix = 'rd';
            }

            return `${day}${daySuffix} of ${month}, ${year}`;
        }

        function formatDateNoYear(dateString) {
            let date = new Date(dateString);
            const day = date.getDate()
            const month = date.toLocaleString('en-US', { month: 'long' });

            let daySuffix = 'th';
            if (day === 1 || day === 21 || day === 31) {
                daySuffix = 'st';
            } else if (day === 2 || day === 22) {
                daySuffix = 'nd';
            } else if (day === 3 || day === 23) {
                daySuffix = 'rd';
            }

            return `${day}${daySuffix} of ${month}`;
        }

        function calculateDefaultEndDate() {
            const currentDate = new Date();
            return new Date(
                currentDate.getTime() - currentDate.getTimezoneOffset() * 60000
            ).toISOString().substring(0, 10);
        };

        function calculateDefaultStartDate() {
            const endDateValue = new Date(endDate.value);
            const startDateValue = new Date(
                endDateValue.getTime() - 7 * 24 * 60 * 60 * 1000
            );
            return startDateValue.toISOString().substring(0, 10);
        };

        onMounted(async () => {
            endDate.value = calculateDefaultEndDate();
            startDate.value = calculateDefaultStartDate();
            dates.value = [startDate.value, endDate.value];
        });

        watch(dates, () => {
            uniqueDates.value = getUniqueDates();
        });

        watch(logbookItems, () => {
            uniqueDates.value = getUniqueDates();
        });

        return {
            panel,
            showDatePickerDialog,
            dates,
            dateRangeText,
            logbookItems,
            uniqueDates,
            dateItem,
            currentDate,
            formatDate,
            formatDateNoYear,
            showFavouriteJourneysDialog,
            favouriteJourneys,
            //imageIds,
            //isFavourite,
            //isNotFavourite,
        };
    },
});
